import {createContext, useContext} from 'react'
import {siteConfig as fallback} from '../config/siteConfig'

export const SiteContentContext = createContext(fallback)

export const useSite = () => useContext(SiteContentContext)
